<template>
  <div class="container-fluid mt-5">
    <card>

      <!-- ========================= INFORMATION ===============================  -->
      <div class="table-responsive mb-2">
        <div class="text-center display-4">
          <span style="margin-bottom: -20px; font-weight: bold;">DETAIL DELIVERY RETURN (SLITTING COIL)</span>

          <a :href="apiUrl+'print-delivery/'+detailDeliveryData.packing_list_no+'?page=1'" target="_BLANK">
            <button type="submit" class="btn btn-sm btn-success btn-fill float-right ml-2">
              <i class="fa fa-file-text"></i> Print
            </button>
          </a>
          <hr style="margin-top: 50px;">
        </div>
        <table class="table table-sm table-bordered">
            <tbody>
                <tr>
                    <td style="background-color: #F0F8FF; font-weight: bold;" width="150">CLIENT / OWNER</td>
                    <td width="300">  {{ detailDeliveryData.client_name }} </td>
                    <td style="background-color: #F0F8FF; font-weight: bold;" width="150">SURAT JALAN NO</td>
                    <td> {{ detailDeliveryData.packing_list_no }} </td>
                </tr>
                <tr>
                    <td style="background-color: #F0F8FF; font-weight: bold;" width="150">TANGGAL</td>
                    <td width="300" colspan="3"> {{ detailDeliveryData.packing_date }} </td>
                </tr>
            </tbody>
        </table>
      </div>

      <!-- ========================= ADDRES ===============================  -->
      <div>
        CUSTOMER (TUJUAN RETUR) :
        <div class="row">
          <div class="col-6">
            <div class="card">
              <textarea style="border: 1px solid white; font-size: 15px; resize: none;" rows="5" cols="40" disabled> Kpd YTH : &#10; {{ detailDeliveryData.client_name }} &#10; {{ detailDeliveryData.client_addres }}</textarea>
            </div>
          </div>
          <div class="col-6">
            <div class="card">
              <textarea style="border: 1px solid white; font-size: 15px; resize: none;" rows="5" cols="40" @change="updateSJ(detailDeliveryData.packing_list_no)" v-model="dataSJ.alamat_kirim"></textarea>
            </div>
          </div>
        </div>
        <p style="margin-bottom: -25px;">Barang-barang berikut dikembalikan (retur) kepada pemilik material.</p>
        <button type="submit" class="btn btn-sm btn-dark btn-fill float-right" @click="addMaterial()">
          Add Material
        </button>
        <hr style="margin-top:40px;">
      </div>

      <!-- ========================= MATERIAL ===============================  -->
      <div class="table-responsive mb-4">
        <table border='1'>
          <thead>
            <tr style="background-color: #F0F8FF;">
              <th style="font-size: 13px; text-align: center;">NO</th>
              <th style="font-size: 13px; text-align: center;">COIL NO</th>
              <th style="font-size: 13px; text-align: center;">PACK</th>
              <th style="font-size: 13px; text-align: center;">DIMENSI</th>
              <th style="font-size: 13px; text-align: center;">BERAT</th>
              <th style="font-size: 13px; text-align: center;">SPECIFICATION</th>
              <th style="font-size: 13px; text-align: center;">PROGRAM NO</th>
              <th style="font-size: 13px; text-align: center;">KETERANGAN</th>
              <th style="font-size: 13px; text-align: center;"></th>
              <th style="display: none" ></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, i) in tableMatTbl.data" :key="i">
              <td style="font-size: 13px; text-align: center;">{{i + 1}}</td>
              <td style="font-size: 13px; text-align: center;">{{row.coil_no}}</td>
              <td style="font-size: 13px; text-align: center;">{{row.pack}}</td>
              <td style="font-size: 13px; text-align: center;">{{row.thick}} x {{row.width}}</td>
              <td style="font-size: 13px; text-align: center;">{{convertRp(row.weight)}}</td>
              <td style="font-size: 13px; text-align: center;">{{row.spec}}</td>
              <td style="font-size: 13px; text-align: center;">{{row.process_program}}</td>
              <td style="font-size: 13px; text-align: center;">{{row.description}}</td>
              <td style="text-align:center;">
                <i class="fa fa-times-circle" aria-hidden="true" title="Batalkan Retur" style="cursor: pointer;" @click="saveMaterial('delete', row.id)"></i>
              </td>
              <td style="display: none" ></td>
            </tr>
            <tr>
              <td colspan="4" style="font-size: 13px; text-align: center; font-weight: bold; ">TOTAL</td>
              <td style="font-size: 13px; font-weight: bold; text-align: center;" >{{convertRp(totalWeight)}}</td>
              <td colspan="3" style="display: none" ></td>
              <td style="display: none" ></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- ========================= FOOTER ===============================  -->
      <div class="card mb-2">
        <p style="margin-left: 5px; margin-bottom: -1px; margin-top: 2px; font-size: 14px;">TRANSPORTER <span style="margin-left: 8px;">:</span>
          <input type="" name="" style="border: 1px solid white;" @change="updateSJ(detailDeliveryData.packing_list_no)" v-model="dataSJ.transporter">
        </p>
        <p style="margin-left: 5px; margin-bottom: -1px; font-size: 14px;">NO KENDARAAN :
          <input type="" name="" style="border: 1px solid white;" @change="updateSJ(detailDeliveryData.packing_list_no)" v-model="dataSJ.no_kendaraan">
        </p>
        <p style="margin-left: 5px; font-size: 14px;">DRIVER <span style="margin-left: 60px;">:</span>
          <input type="" name="" style="border: 1px solid white;" @change="updateSJ(detailDeliveryData.packing_list_no)" v-model="dataSJ.driver">
        </p>

        <div class="row">
          <div class="col-3 text-center">
            <p style="margin-left: 5px; margin-bottom: 120px; margin-top: 23px; font-size: 13px;">DI TERIMA OLEH</p>
          </div>
          <div class="col-3 text-center">
            <p style="margin-left: 5px; margin-bottom: 120px; margin-top: 23px; font-size: 13px;">DRIVER</p>
            <p style="margin-left: 5px; font-size: 13px; margin-bottom: -20px;">
              {{ dataSJ.driver }}<hr>
            </p>
          </div>
          <div class="col-3 text-center">
            <p style="margin-left: 5px; margin-bottom: 120px; margin-top: 23px; font-size: 13px;">SECURITY</p>
            <p style="margin-left: -10px; font-size: 13px; margin-bottom: -25px;">
              <input type="" name="" style="border: 1px solid white; text-align: center;" @change="updateSJ(detailDeliveryData.packing_list_no)" v-model="dataSJ.security"><hr>
            </p>
          </div>
          <div class="col-3 text-center">
            <p style="margin-left: 5px; margin-bottom: 120px; margin-top: 23px; font-size: 13px;">PT. BUANA CENTRA KARYA</p>
            <p style="margin-left: -10px; font-size: 13px; margin-bottom: -25px;">
              <input type="" name="" style="border: 1px solid white; text-align: center;" @change="updateSJ(detailDeliveryData.packing_list_no)" v-model="dataSJ.delegated_pt"><hr>
            </p>
          </div>
        </div>
      </div>

      <!-- MODAL ADD MATERIAL-->
      <div>
         <modal :show.sync="form.show">
           <template slot="header">
              <h5 class="modal-title" id="exampleModalLabel">{{form.title}}</h5>
           </template>
           <div>

            TOTAL QTY : {{tableMatMdl.data.length}}<br>
            TOTAL WEIGHT : {{convertRp(totalWeightMdl)}}
            <i class="fa fa-check-circle text-primary fa-lg ml-2" style="cursor: pointer;" aria-hidden="true" title="Add Material All" @click="saveMaterial('all')"></i>

            <div class="row">
              <div class="col-6">
                <base-input
                      type="text"
                      label="Search Coil No"
                      placeholder="Search Coil No"
                      v-model="search.coil_no"
                      @change="getMaterialMdl()">
                </base-input>
              </div>
              <div class="col-6">
                <base-input
                      type="text"
                      label="Search Surat Jalan No"
                      placeholder="Search Surat Jalan No"
                      v-model="search.travel_latter_no"
                      @change="getMaterialMdl()">
                </base-input>
              </div>
              <div class="col-6">
                <base-input
                      type="text"
                      label="Search Thick / mm"
                      placeholder="Search Thick / mm"
                      v-model="search.thick"
                      @change="getMaterialMdl()">
                </base-input>
              </div>
              <div class="col-6">
                <base-input
                      type="text"
                      label="Search Width / mm"
                      placeholder="Search Width / mm"
                      v-model="search.width"
                      @change="getMaterialMdl()">
                </base-input>
              </div>
            </div>

            <div class="scroll">
              <table class="table">
                <thead>
                  <slot name="columns">
                    <tr style="background-color: #F0F8FF;">
                      <th></th>
                      <th style="font-size: 13px;">Coil No</th>
                      <th style="font-size: 13px;">Surat Jalan No</th>
                      <th style="font-size: 13px;">Pack</th>
                      <th style="font-size: 13px;">Thick</th>
                      <th style="font-size: 13px;">Width</th>
                      <th style="font-size: 13px;">Weight</th>
                      <th style="font-size: 13px;">Spec</th>
                      <th style="font-size: 13px;">Program No</th>
                    </tr>
                  </slot>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in tableMatMdl.data" :key="i">
                    <td>
                      <i class="fa fa-plus-square text-primary" aria-hidden="true" title="Add Material" style="cursor: pointer;" @click="saveMaterial('add', row.id)"></i>
                    </td>
                    <td style="font-size: 13px;">{{row.coil_no}}</td>
                    <td style="font-size: 13px;">{{row.travel_latter_no}}</td>
                    <td style="font-size: 13px;">{{row.pack}}</td>
                    <td style="font-size: 13px;">{{row.thick}}</td>
                    <td style="font-size: 13px;">{{row.width}}</td>
                    <td style="font-size: 13px;">{{row.weight}}</td>
                    <td style="font-size: 13px;">{{row.spec}}</td>
                    <td style="font-size: 13px;">{{row.process_program}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
           </div>
           <template slot="footer">
           </template>
         </modal>
      </div>

    </card>
  </div>
</template>
<script>
  import Card from '@/components/Cards/Card.vue'
  import Modal from '@/components/Modal.vue'
  import config from '@/configs/config';
  import delivery from '@/services/delivery.service';
  import Api from '@/helpers/api';

  export default {
    components: {
      Card,
      Modal,
    },
    data () {
      return {
        form: {
            add: true,
            title: "Add Material",
            show: false
        },
        detailDeliveryData: {},
        tableMatTbl: {
          data: []
        },
        tableMatMdl: {
          data: []
        },
        totalWeight: '',
        totalWeightMdl: '',
        apiUrl :config.apiUrl,
        storageUrl : config.storageUrl,
        tokenApi : '',

        dataSJ : {
          alamat_kirim: '',
          transporter: '',
          no_kendaraan: '',
          driver: '',
          gudang: '',
          security: '',
          delegated_pt: '',
        },
        search: {
          coil_no: '',
          travel_latter_no: '',
          thick: '',
          width: '',
        },
      }
    },
    mounted(){
      this.get();
      this.getDataSJ();
      this.tokenApi = 'Bearer '+localStorage.getItem('token');
    },
    methods: {
      get() {
        let context = this;
        Api(context, delivery.showDelivery(context.$route.params.packing_list_no)).onSuccess(function(response) {
            context.detailDeliveryData = response.data.data;
        }).onFinish(function() {
             context.getMaterialTbl();
        })
        .call()
      },
      getDataSJ() {
        let context = this;
        Api(context, delivery.getDataSJ(context.$route.params.packing_list_no)).onSuccess(function(response) {
            context.dataSJ = response.data.data.data;
        })
        .onError(function(error) {
            context.dataSJ = []
        })
        .call()
      },
      updateSJ(packing_list_no){
        let api     = null;
        let context = this;

        api = Api(context, delivery.updateSJ(packing_list_no, {
            alamat_kirim : context.dataSJ.alamat_kirim,
            transporter : context.dataSJ.transporter,
            no_kendaraan : context.dataSJ.no_kendaraan,
            driver : context.dataSJ.driver,
            gudang : context.dataSJ.gudang,
            security : context.dataSJ.security,
            delegated_pt : context.dataSJ.delegated_pt,

            total_qty : context.detailDeliveryData.qty,
            total_weight : context.detailDeliveryData.weight,
          }));
        api.onSuccess(function(response) {
            context.notifyVue(response.data.message, 'top', 'right', 'info')
        }).onError(function(error) {
            context.notifyVue('Update Failed', 'top', 'right', 'danger')
        }).onFinish(function() {
            context.get()
        })
        .call();
      },
      convertRp(bilangan) {
        if (bilangan) {
          var number_string = bilangan.toString(),
              sisa    = number_string.length % 3,
              rupiah  = number_string.substr(0, sisa),
              ribuan  = number_string.substr(sisa).match(/\d{3}/g);

          if(ribuan){
            var separator = sisa ? '.' : '';
            rupiah += separator + ribuan.join('.');
            return rupiah
          }else{
            return bilangan
          }
        }
      },
      getMaterialMdl() {
        let context = this;
        Api(context, delivery.getMaterialMdlReturnSlit({owner: context.detailDeliveryData.client_name, coil_no: context.search.coil_no, travel_latter_no: context.search.travel_latter_no, thick: context.search.thick, width: context.search.width})).onSuccess(function(response) {
            context.tableMatMdl.data = response.data.data.data;
            context.totalWeightMdl   = response.data.data.totalWeight;
        })
        .onError(function(error) {
            context.tableMatMdl.data = []
        })
        .call()
      },
      getMaterialTbl() {
        let context = this;
        Api(context, delivery.getMaterialTblReturnSlit({surat_jalan_no: context.detailDeliveryData.packing_list_no})).onSuccess(function(response) {
            context.tableMatTbl.data = response.data.data.data;
            context.totalWeight      = response.data.data.totalWeight;
        })
        .onError(function(error) {
            context.tableMatTbl.data = []
        })
        .call()
      },
      addMaterial() {
        this.form.add   = true;
        this.form.show  = true;
        this.form.title = "Add Material";
        this.search.coil_no = '';
        this.search.travel_latter_no = '';
        this.search.thick = '';
        this.search.width = '';
        this.getMaterialMdl()
      },
      saveMaterial(type, id){
        let api = null;
        let context = this;
        let formData = new FormData();

        formData.append('packing_list_no', this.detailDeliveryData.packing_list_no);
        formData.append('owner', this.detailDeliveryData.client_name);
        formData.append('coil_no', this.search.coil_no);
        formData.append('travel_latter_no', this.search.travel_latter_no);
        formData.append('thick', this.search.thick);
        formData.append('width', this.search.width);
        formData.append('type', type);
        if (id != undefined) {
          formData.append('id', id);
        }

        api = Api(context, delivery.addMaterialReturnSlit(formData));
        api.onSuccess(function(response) {
            context.notifyVue('Data Berhasil di Simpan', 'top', 'right', 'info')
        }).onError(function(error) {
            context.notifyVue('Data Gagal di Simpan' , 'top', 'right', 'danger')
        }).onFinish(function() {
            context.getMaterialMdl();
            context.getMaterialTbl();
        })
        .call();
      },
      notifyVue(message, verticalAlign, horizontalAlign, type) {
        this.$notifications.notify(
        {
            message: message,
            icon: 'nc-icon nc-notification-70',
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: type
        })
      },
    }
  }

</script>
<style lang='scss' scoped>
  ::placeholder {
    color: #DCDCDC;
    padding-top: 10px;
    padding-left: 14px;
  }
</style>
